module.exports = __webpack_public_path__ + "img/Group_sec-5.a36aade7.png";